<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>레벨 테스트 제출 세션 검토</h2>
    </div>

    <Navigation />

    <div class="box one filter levelTest">
      <div class="filters">
        <div class="flex">
          <p>상태</p>
          <el-select v-model="status" clearable placeholder="전체">
            <el-option
              v-for="item in statuses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="flex">
          <p>결과</p>
          <el-select v-model="outcome" clearable placeholder="전체">
            <el-option
              v-for="item in outcomes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="flex">
          <p>레벨</p>
          <el-select v-model="level" clearable placeholder="전체">
            <el-option
              v-for="item in levels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="flex searchWrap">
          <p>검색</p>
          <input
            type="text"
            v-model="searchWord"
            placeholder="이메일 또는 닉네임"
            @keyup.enter="search"
          />
        </div>
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one">
      <table>
        <colgroup>
          <col style="width: 8%" />
          <col style="width: 15%" />
          <col style="width: 18%" />
          <col style="width: 10%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 10%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>사용자</th>
          <th>이메일</th>
          <th>테스트 레벨</th>
          <th>상태</th>
          <th>결과</th>
          <th>문항 수</th>
          <th>제출 시각</th>
        </tr>
        <tr v-for="(data, i) in sessionList" :key="i">
          <td>{{ total - ((currentPage - 1) * 20 + i) }}</td>
          <td>
            <router-link to @click.native="moveDetail(data._id)">
              {{ data.user?.nickname || "-" }}
            </router-link>
          </td>
          <td>{{ data.user?.email || "-" }}</td>
          <td>{{ getLevelLabel(data.examLevel) }}</td>
          <td>{{ getLabel(statuses, data.status) }}</td>
          <td :class="{ primary: data.outcome === 'passed' }">
            {{ getLabel(outcomes, data.outcome) }}
          </td>
          <td>{{ Array.isArray(data.datas) ? data.datas.length : 0 }}</td>
          <td>{{ formatDate(data.submittedAt || data.createdAt) }}</td>
        </tr>
      </table>

      <div class="pagination" v-if="sessionList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        />
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { fetchLevelTestSessions } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import Navigation from "../Navigation.vue";
import {
  getLevelLabel,
  LEVEL_TEST_LEVELS,
  LEVEL_TEST_OUTCOMES,
  LEVEL_TEST_STATUSES,
} from "@/config/levelTest";

export default {
  name: "levelTestSessionManage",
  components: {
    Navigation,
    NoData,
  },
  data() {
    return {
      loading: false,
      moment,
      sessionList: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      searchWord: "",
      status: "",
      outcome: "",
      level: "",
      statuses: LEVEL_TEST_STATUSES,
      outcomes: LEVEL_TEST_OUTCOMES,
      levels: LEVEL_TEST_LEVELS,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "6");
  },
  mounted() {
    this.syncFromRoute();
    this.getSessionList();
  },
  methods: {
    formatDate(value) {
      return value ? moment(value).format("YYYY.MM.DD HH:mm") : "-";
    },
    getLevelLabel,
    getLabel(options, value) {
      const matched = options.find((item) => item.value === value);
      return matched ? matched.label : value || "-";
    },
    syncFromRoute() {
      this.currentPage = Number(this.$route.query.page || 1);
      this.searchWord = this.$route.query.searchWord || "";
      this.status = this.$route.query.status || "";
      this.outcome = this.$route.query.outcome || "";
      this.level = this.$route.query.level || "";
    },
    pushQuery() {
      const query = {
        page: String(this.currentPage),
      };
      if (this.searchWord) query.searchWord = this.searchWord;
      if (this.status) query.status = this.status;
      if (this.outcome) query.outcome = this.outcome;
      if (this.level) query.level = this.level;
      this.$router.push({ name: "levelTestSessionManage", query });
      this.getSessionList();
    },
    search() {
      this.currentPage = 1;
      this.pushQuery();
    },
    reset() {
      this.currentPage = 1;
      this.searchWord = "";
      this.status = "";
      this.outcome = "";
      this.level = "";
      this.pushQuery();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.pushQuery();
    },
    moveDetail(id) {
      this.$router.push({
        name: "levelTestSessionDetail",
        query: {
          id,
          page: this.currentPage,
          searchWord: this.searchWord,
          status: this.status,
          outcome: this.outcome,
          level: this.level,
        },
      });
    },
    getSessionList() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
        searchWord: this.searchWord,
        status: this.status,
        outcome: this.outcome,
        level: this.level,
      };
      fetchLevelTestSessions(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.sessionList = res.data.data || [];
            this.total = res.data.total || 0;
          } else {
            alert(res.data.message || "세션 목록을 불러오지 못했습니다.");
          }
        })
        .catch((err) => {
          alert(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.levelTestNav {
  margin: 80px 10px 30px 30px;
}
.filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 20px;
}

.filters .flex {
  align-items: center;
}

.filters .flex p {
  width: 110px;
}
</style>
